import { uniqBy } from 'lodash-es'

export const getSlotsForRange = async (
  startLuxon,
  endLuxon,
  durationInMinutesValue,
  fetchEvents,
  slotIncrementMinutes = 15
) => {
  const slots = []

  let intervals = await fetchAvailableIntervals(
    startLuxon,
    endLuxon,
    fetchEvents
  )

  intervals.map((interval) => {
    let start = interval.start

    // Advance to the next slot increment
    if (start.minute % slotIncrementMinutes !== 0) {
      start = start.plus({
        minutes:
          slotIncrementMinutes - (start.minute % slotIncrementMinutes),
      })
    }

    while (start.plus({ minutes: durationInMinutesValue }) <= interval.end) {
      const end = start.plus({ minutes: durationInMinutesValue })
      slots.push({ start, end })
      start = start.plus({ minutes: slotIncrementMinutes })
    }
  })

  return uniqBy(slots, (slot) => slot.start.toISO()).filter(
    (slot) =>
      slot.start >= startLuxon && slot.start < endLuxon && slot.end > startLuxon
  )
}

const fetchAvailableIntervals = async (startLuxon, endLuxon, fetchEvents) => {
  const zone = startLuxon.zone
  const events = await fetchEvents({
    start: startLuxon.toJSDate(),
    end: endLuxon.toJSDate(),
  })

  return events
    .filter((e) => e.groupId === 'available')
    .map((e) => ({
      start: e.extendedProps.startLuxon.setZone(zone),
      end: e.extendedProps.endLuxon.setZone(zone),
    }))
}
